import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import './styles/ComplianceRateCircle.css';

function ComplianceRateCircle({ percentage, size = 140 }) {
  const data = [
    { name: 'Passed', value: percentage },
    { name: 'Remaining', value: 100 - percentage },
  ];

  const COLORS = ['#4caf50', '#e0e0e0'];

  return (
    <div className="compliance-rate-circle-wrapper">
      <div style={{ position: 'relative', width: size, height: size }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx={size / 2}
              cy={size / 2}
              innerRadius={size * 0.38}
              outerRadius={size * 0.47}
              startAngle={90}
              endAngle={-270}
              dataKey="value"
              animationDuration={800}
              animationBegin={0}
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index]} stroke="none" />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>

        {/* 中間的百分比數字 */}
        <div className="rate-circle-label">
          <div className="rate-percentage">{percentage}%</div>
        </div>
      </div>
    </div>
  );
}

export default ComplianceRateCircle;
